<template>
    <card>
        <div>
            <h4 class="text-muted">Actions</h4>
            <div class="btn-group ">
                <el-tooltip
                    :content="'Coming soon!'"
                    :open-delay="300"
                    effect="dark"
                    placement="top">
                    <base-button @click="showBuyNumberModal = true" disabled="disabled" type="primary">Buy Number
                    </base-button>
                </el-tooltip>
            </div>
            <BuyNumberModal :show.sync="showBuyNumberModal"></BuyNumberModal>
        </div>
        <div class="mt-3">
            <phone-numbers-table></phone-numbers-table>

        </div>

    </card>
</template>

<script>
    import PhoneNumbersTable from "./PhoneNumbersTable";
    import BuyNumberModal from "./BuyNumberModal";

    export default {
        components: {
            BuyNumberModal,
            PhoneNumbersTable
        },
        data() {
            return {
                showBuyNumberModal: false,
            };
        },
        computed: {
            enableRTL() {
                return this.$route.query.enableRTL;
            },
            isRTL() {
                return this.$rtl.isRTL;
            },

        },
        methods: {},
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }


        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    };
</script>
<style></style>
